attendeeList.factory('attendeeListService', [
    '$rootScope',
    '$filter',
    'logService',
    'socketService',
    'helperService',
    'attendeeService',
    'localizationService',
    'meetingService',
    'attendeeListStateService',
    function (
        $rootScope,
        $filter,
        logService,
        socketService,
        helperService,
        attendeeService,
        localizationService,
        meetingService,
        attendeeListStateService
    ) {
        const logger = logService.createLoggerWithSource('attendeeListService');
        var attendeeList = [];
        var invitedAttendeeList = [];
        var maxAttendeeCountReached = 0;

        var currentTalkers = {};
        var currentTalkerNames = ''; //Stringified list of current talker names, separated by commas

        var genericGravatarImg =
            helperService.getLocationProtocol() +
            '://' +
            helperService.getLocationHost() +
            '/AccountManager/images/default-avatar-40-im.png';

        var service = {
            getAttendeeList: getAttendeeList,
            getInvitedAttendeeList: getInvitedAttendeeList,
            updateList: updateList,
            updateInvitedList: updateInvitedList,
            updatePartial: updatePartial,
            updatePartialProperty: updatePartialProperty,
            updateInvitedPartialProperty: updateInvitedPartialProperty,
            retrieveListFromServer: retrieveListFromServer,
            retrieveInvitedListFromServer: retrieveInvitedListFromServer,
            addAttendee: addAttendee,
            findAttendee: findAttendee,
            removeAttendee: removeAttendee,
            removeInvitedAttendee: removeInvitedAttendee,
            getAnnotationAttendees: getAnnotationAttendees,
            getAttendeeCountForSimulcastCondition: getAttendeeCountForSimulcastCondition,
            getAttendeeCountForDisplay: getAttendeeCountForDisplay,
            getAttendeeCountForE2EECondition: getAttendeeCountForE2EECondition,
            getCurrentTalkers: getCurrentTalkers,
            addCurrentTalker: addCurrentTalker,
            removeCurrentTalker: removeCurrentTalker,
            getNameFromAttendeeObj: getNameFromAttendeeObj,
            resetCurrentTalkersList: resetCurrentTalkersList,
            populateCurrentTalkersList: populateCurrentTalkersList,
            getHost: getHost,
            generateNameStringList: generateNameStringList,
            getMaxAttendeeCountReached: getMaxAttendeeCountReached,
            setMaxAttendeeCountReached: setMaxAttendeeCountReached,
            getGroupLabelForAttendeeCount: getGroupLabelForAttendeeCount
        };

        $rootScope.$on('attendee-list', onAttendeeList);
        $rootScope.$on('invited-attendee-partial-property', onInvitedAttendeePartialProperty);
        $rootScope.$on('attendee-partial-property', onAttendeePartialProperty);
        $rootScope.$on('attendee-partial', onAttendeePartial);
        $rootScope.$on('remove-attendee', onRemoveAttendee);
        $rootScope.$on('remove-invited-attendee', onRemoveInvitedAttendee);
        $rootScope.$on('clear-invited-attendees', onClearInvitedAttendees);
        $rootScope.$on('add-attendee', onAddAttendee);
        $rootScope.$on('audio-updated', onAudioUpdated);
        $rootScope.$on('video-updated', onVideoUpdated);
        $rootScope.$on('screen-video-updated', onScreenVideoUpdated);
        $rootScope.$on('attendee-audio-disconnect-state-updated', onAttendeeAudioDisconnectStateUpdated);

        $rootScope.$on('node-reconnected', onNodeReconnected);

        return service;

        ////////////////////////

        function getAttendeeList() {
            return attendeeList;
        }

        function getInvitedAttendeeList() {
            return invitedAttendeeList;
        }

        function getAttendeeCountForE2EECondition() {
            return service.getAttendeeList().filter(function (attendee) {
                // skip 'e2ee not supported' users because they will be kicked when e2ee is enabled
                return (
                    !attendee.isPhoneUser &&
                    !attendee.phoneMemberId &&
                    !attendee.switchedToPhone &&
                    attendee.supportsE2EE
                );
            }).length;
        }

        function getAttendeeCountForSimulcastCondition() {
            var attendees = [];
            service.getAttendeeList().forEach(function (attendee) {
                if (!attendee.isPhoneUser) {
                    attendees.push(attendee);
                }
            });
            return attendees;
        }

        function getAttendeeCountForDisplay() {
            return service.getAttendeeList().length;
        }

        function getMaxAttendeeCountReached() {
            return maxAttendeeCountReached;
        }

        function setMaxAttendeeCountReached(count) {
            maxAttendeeCountReached = Math.max(maxAttendeeCountReached, count);
        }

        function getGroupLabelForAttendeeCount(count) {
            if (count === 0) {
                return 'none';
            }

            var groups = { 0: '1-5', 1: '6-10', 2: '11-15', 3: '16-20', 4: '21-25', 5: '26-30', 6: 'over 30' };
            var groupId = Math.min(Math.floor((count - 1) / 5), 6);
            return groups[groupId];
        }

        function updateList(newList) {
            var oldCount = service.getAttendeeCountForSimulcastCondition().length;
            attendeeList = newList;
            attendeeListStateService.attendees = newList;
            var newCount = service.getAttendeeCountForSimulcastCondition().length;
            service.setMaxAttendeeCountReached(service.getAttendeeCountForDisplay());
            $rootScope.$broadcast('attendee-list-updated', {
                displayCount: service.getAttendeeCountForDisplay(),
                action: 'updateList'
            });
            if (oldCount != newCount) {
                $rootScope.$broadcast('attendee-list-count-updated', { old: oldCount, new: newCount });
            }

            if (!helperService.isVideoRoomApplication()) {
                var list = service.getAttendeeList();
                var hasRoomClient = false;
                list.forEach(function (att) {
                    if (att.uniteRoomsUserId) {
                        hasRoomClient = true;
                    }
                });

                if (hasRoomClient) {
                    $rootScope.$broadcast('room-client-detected');
                }
            }
        }

        function updateInvitedList(newList) {
            for (var i = 0; i < newList.length; i++) {
                newList[i].attendantId = 'localAtt' + newList[i].trackingId;
                newList[i].attendeeType = 'invite';
                newList[i].screenName = newList[i].name;
                if (!newList[i].imageURL || newList[i].imageURL === '') {
                    newList[i].imageURL = genericGravatarImg;
                }
            }
            invitedAttendeeList = newList;
            attendeeListStateService.invitedAttendees = newList;
            $rootScope.$broadcast('invited-attendee-list-updated');
        }

        function updatePartial(individual) {
            for (var i = 0; i < attendeeList.length; i++) {
                if (attendeeList[i].attendantId === individual.attendantId) {
                    var oldCount = service.getAttendeeCountForSimulcastCondition().length;
                    attendeeList[i] = individual;
                    var count = service.getAttendeeCountForSimulcastCondition().length;
                    if (oldCount != count) {
                        $rootScope.$broadcast('attendee-list-count-updated', { old: oldCount, new: count });
                    }
                    attendeeListStateService.attendees = attendeeList;
                    break;
                }
            }

            $rootScope.$broadcast('attendee-list-updated', individual);
        }

        function updatePartialProperty(data) {
            if (!data.attendantId || !data.propName) {
                return;
            }
            for (var i = 0; i < attendeeList.length; i++) {
                if (attendeeList[i].attendantId === data.attendantId) {
                    attendeeList[i][data.propName] = data.propValue;

                    //startedTalking property is used to track the order of who in the list started speaking first
                    if (data.propName === 'isTalking') {
                        if (data.propValue === true) {
                            service.addCurrentTalker(attendeeList[i]);
                        } else {
                            service.removeCurrentTalker(attendeeList[i]);
                        }
                    } else if (data.propName === 'isSelfMuted') {
                        service.removeCurrentTalker(attendeeList[i]);
                    }

                    $rootScope.$broadcast('attendee-list-updated', {
                        attendantId: data.attendantId,
                        propName: data.propName
                    });
                    attendeeListStateService.attendees = attendeeList;
                    break;
                }
            }
        }

        function updateInvitedPartialProperty(data) {
            if (typeof data.trackingId === 'undefined' || data.trackingId === null || !data.propName) {
                return;
            }

            for (var i = 0; i < invitedAttendeeList.length; i++) {
                if (invitedAttendeeList[i].trackingId === data.trackingId) {
                    invitedAttendeeList[i][data.propName] = data.propValue;
                    attendeeListStateService.invitedAttendees = invitedAttendeeList;
                    $rootScope.$broadcast('invited-attendee-list-updated');
                    break;
                }
            }
        }

        function retrieveListFromServer() {
            if (
                !meetingService.isWebinar() ||
                attendeeService.getIsPresenter() ||
                meetingService.getWebinarOptions().showAttendeeList
            ) {
                socketService.send({
                    message: 'attendee-list',
                    data: {},
                    callback: function (newList) {
                        service.updateList(newList);

                        logger.log('Populating Current Talker list after attendee list retrieval');
                        service.populateCurrentTalkersList();
                    }
                });
            }
        }

        function retrieveInvitedListFromServer() {
            socketService.send({
                message: 'invited-attendee-list',
                data: {},
                callback: service.updateInvitedList
            });
        }

        function addAttendee(individual) {
            var existingAttendee = service.findAttendee(individual.attendantId);

            if (existingAttendee) {
                logger.log('Attendee already exists... replacing existing copy in attendee list');
                service.removeAttendee(existingAttendee);
            }

            var oldCount = service.getAttendeeCountForSimulcastCondition().length;
            attendeeList.push(individual);

            if (!helperService.isVideoRoomApplication()) {
                if (individual.uniteRoomsUserId) {
                    $rootScope.$broadcast('room-client-detected');
                }
            }

            service.setMaxAttendeeCountReached(service.getAttendeeCountForDisplay());
            $rootScope.$broadcast('attendee-list-updated', {
                displayCount: service.getAttendeeCountForDisplay(),
                action: 'addAttendee',
                attendantId: individual.attendantId
            });
            var count = service.getAttendeeCountForSimulcastCondition().length;
            if (oldCount != count) {
                $rootScope.$broadcast('attendee-list-count-updated', { old: oldCount, new: count });
            }
            attendeeListStateService.attendees = attendeeList;
        }

        function removeAttendee(individual) {
            var oldCount = service.getAttendeeCountForSimulcastCondition().length;
            for (var i = 0; i < attendeeList.length; i++) {
                if (attendeeList[i].attendantId === individual.attendantId) {
                    service.removeCurrentTalker(attendeeList[i]);

                    attendeeList.splice(i, 1);
                    var count = service.getAttendeeCountForSimulcastCondition().length;
                    $rootScope.$broadcast('attendee-list-updated', {
                        displayCount: service.getAttendeeCountForDisplay(),
                        action: 'removeAttendee',
                        attendantId: individual.attendantId
                    });
                    if (oldCount != count) {
                        $rootScope.$broadcast('attendee-list-count-updated', { old: oldCount, new: count });
                    }
                    attendeeListStateService.attendees = attendeeList;
                    return;
                }
            }
        }

        function removeInvitedAttendee(individual) {
            for (var i = 0; i < invitedAttendeeList.length; i++) {
                if (individual.trackingId === invitedAttendeeList[i].trackingId) {
                    invitedAttendeeList.splice(i, 1);
                    attendeeListStateService.invitedAttendees = invitedAttendeeList;
                    $rootScope.$broadcast('invited-attendee-list-updated');
                    break;
                }
            }
        }

        function findAttendee(attendantId) {
            for (i = 0; i < attendeeList.length; i++) {
                if (attendeeList[i].attendantId === attendantId) {
                    return attendeeList[i];
                }
            }

            return false;
        }

        //
        function getAnnotationAttendees(filterId) {
            var attendeeList = service.getAttendeeList();
            var elegibleAttendees = [];

            attendeeList.forEach(function (att) {
                if (att && !att.isPhoneUser && !att.isMobileAppUser && att.hasWebRTC && att.attendantId !== filterId) {
                    elegibleAttendees.push(att);
                }
            });

            return elegibleAttendees;
        }

        function onAttendeeList(e, data) {
            service.updateList(data);
        }

        function onAttendeePartial(e, data) {
            service.updatePartial(data);
        }

        function onAttendeePartialProperty(e, data) {
            service.updatePartialProperty(data);
        }

        function onInvitedAttendeePartialProperty(e, data) {
            service.updateInvitedPartialProperty(data);
        }

        function onAddAttendee(e, data) {
            service.addAttendee(data);
        }

        function onRemoveAttendee(e, data) {
            service.removeAttendee(data);
        }

        function onRemoveInvitedAttendee(e, data) {
            service.removeInvitedAttendee(data);
        }

        function onClearInvitedAttendees(e, data) {
            invitedAttendeeList = [];
            attendeeListStateService.invitedAttendees = [];
            $rootScope.$broadcast('invited-attendee-list-updated');
        }

        function onAudioUpdated(e, data) {
            service.updatePartialProperty({
                attendantId: data.attendantId,
                propName: 'isSelfMuted',
                propValue: data.isSelfMuted
            });
        }

        function onVideoUpdated(e, data) {
            service.updatePartialProperty({
                attendantId: data.attendantId,
                propName: 'isVideoMuted',
                propValue: data.isMuted
            });
        }

        // server has marked screen video for this participant (see multishare user pair)
        function onScreenVideoUpdated(e, data) {
            service.updatePartialProperty({
                attendantId: data.attendantId,
                propName: 'hasScreenVideo',
                propValue: data.isEnabled
            });
        }

        function onAttendeeAudioDisconnectStateUpdated(e, data) {
            service.updatePartialProperty({
                attendantId: data.attendantId,
                propName: 'audioDisconnected',
                propValue: data.audioDisconnected
            });
        }

        function getCurrentTalkers() {
            return currentTalkerNames;
        }

        function generateNameStringList() {
            if (currentTalkers) {
                currentTalkerNames = Object.values(currentTalkers).join(', ');
            } else {
                logger.log('generateNameStringList - invalid current talker Object');
                currentTalkerNames = '';
            }
        }

        function addCurrentTalker(attendee) {
            var name = service.getNameFromAttendeeObj(attendee);
            var attendeeId = attendee.attendantId;
            if (name) {
                if (!currentTalkers[attendeeId]) {
                    currentTalkers[attendeeId] = name;
                    service.generateNameStringList();
                }
            } else {
                logger.warn('addCurrentTalker', 'invalid attendee name', name);
            }
        }

        function removeCurrentTalker(attendee) {
            var name = service.getNameFromAttendeeObj(attendee);
            var attendantId = attendee.attendantId;
            if (name) {
                if (currentTalkers[attendantId]) {
                    delete currentTalkers[attendantId];
                    service.generateNameStringList();
                }
            } else {
                logger.warn('removeCurrentTalker', 'invalid attendee name', name);
            }
        }

        function getNameFromAttendeeObj(attendee) {
            var name = null;

            if (attendee) {
                if (attendee.isPhoneUser) {
                    name = attendeeService.getIsHost()
                        ? $filter('phoneFilter')(attendee.screenName)
                        : localizationService.translate('COMMON.PHONE_CALLER');
                } else {
                    name = $filter('firstNameLastInitial')(attendee.screenName);
                }
            }

            return name;
        }

        function resetCurrentTalkersList() {
            currentTalkers = {};
            currentTalkerNames = '';
        }

        function populateCurrentTalkersList() {
            service.resetCurrentTalkersList();

            var list = service.getAttendeeList();

            list.forEach(function (att) {
                if (att.isTalking && !att.isSelfMuted) {
                    service.addCurrentTalker(att);
                }
            });
        }

        function onNodeReconnected() {
            service.retrieveListFromServer();
        }

        function getHost() {
            var list = service.getAttendeeList();
            if (list) {
                return list.find(function (attendee) {
                    return attendee.attendeeType == 'host';
                });
            }
            return null;
        }
    }
]);
